<template>
  <div class="sp-google-map"><slot /></div>
  <Teleport v-if="host" :to="host">
    <div ref="canvas" class="sp-google-map__canvas" :style="canvasStyle"></div>
  </Teleport>
</template>

<script setup>
import { useTemplateRef } from "vue";
import { useExpose } from "#ce/composables/useExpose";
import { useHostElement } from "#ce/composables/useHostElement";
import { useGoogleMap } from "./composables/useGoogleMap";
import { mapProps } from "./props";

defineOptions({ inheritAttrs: false });

const canvasStyle = Object.freeze({ width: "100%", height: "100%" });
const props = defineProps(mapProps);
const emit = defineEmits(["map-ready", "map-error", "map-dispose", "viewport-change"]);
const host = useHostElement();
const { initialize, currentMap } = useGoogleMap(props, emit, useTemplateRef("canvas"));

const { exposeMethods, exposeProperties } = useExpose();
exposeMethods({ initialize });
exposeProperties({ map: { get: currentMap } });
</script>

<style>
:host {
  display: block;
  height: var(--sp-comp-google-map-height, 100%);
  min-height: var(--sp-comp-google-map-min-height, 0);
}
</style>

<style scoped>
.sp-google-map {
  height: 100%;
}
</style>
